import {Injectable} from '@angular/core';
import SewingPatternProject from '../../models/sewing-pattern-project.model';

import {Capacitor, FilesystemDirectory, FilesystemEncoding, Plugins} from '@capacitor/core';
import {Platform, ToastController} from '@ionic/angular';
import {ConfiguratorService} from '../configurator/configurator.service';

@Injectable({
    providedIn: 'root'
})
export class PatternShareService {

    constructor(private platform: Platform,
                private toastController: ToastController,
                private configuratorService: ConfiguratorService) {

    }

    async share(sewingPatternProject: SewingPatternProject) {
        const png = (await this.configuratorService.generateImageFromSewingPatternProject(sewingPatternProject, true)) as string;

        if (this.platform.is('ios')) {
            // On ios we can just open the share dialog to download the file.
            await Plugins.Filesystem.writeFile({
                path: `${sewingPatternProject.id}.lybstes.jpeg`,
                directory: FilesystemDirectory.ExternalStorage,
                data: png,
                recursive: true
            });

            await Plugins.Share.share({
                url: ((await Plugins.Filesystem.getUri({
                    path: `${sewingPatternProject.id}.lybstes.jpeg`,
                    directory: FilesystemDirectory.ExternalStorage
                })).uri),
            });
        } else if (this.platform.is('android')) {
            try {
                await Plugins.Filesystem.requestPermissions();

                await Plugins.Filesystem.mkdir({
                    path: `lybstes`,
                }).catch((error) => console.error(error));

                await Plugins.Filesystem.writeFile({
                    path: `lybstes/${sewingPatternProject.id}.lybstes.jpeg`,
                    directory: FilesystemDirectory.ExternalStorage,
                    data: png,
                    recursive: true
                });
            } catch (error) {
                alert('Das Schnittmuster konnte nicht in deiner Gallery gespeichert werden.');
            }

        } else {
            const downloadLink = document.createElement('a');
            downloadLink.href = png;
            downloadLink.download = `${sewingPatternProject.id}.png`;
            document.body.append(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        }
    }
}
